<template>
  <div>
    <h1 class="page-header">{{ $t('termsemester.termsemester') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.academicYear')
                }}</label>
                <div class="col-md-8">
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('ac_year_id') }"
                    v-model.number="model.ac_year_id"
                    @change="getTermOrder"
                  >
                    <option value="">{{ $t('select') }}</option>
                    <option
                      v-for="(acYear, index) in acYears"
                      :key="index"
                      :value="acYear.ac_year_id"
                    >
                      {{ acYear.ac_year }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('ac_year_id')">
                    {{ errors.first('ac_year_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.subProgram')
                }}</label>
                <div class="col-md-8">
                  <ts-search-select
                    v-model.number="model.acps_id"
                    :options="subPrograms"
                  >
                  </ts-search-select>
                  <div class="validate" v-if="errors.has('acps_id')">
                    {{ errors.first('acps_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">Degree</label>
                <div class="col-md-8">
                  <ts-search-select
                    v-model.number="model.level_id"
                    :options="levels"
                  >
                  </ts-search-select>
                  <div class="validate" v-if="errors.has('level_id')">
                    {{ errors.first('level_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('termsemester.academicTerm')
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model="model.term_name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('term_name') }"
                    :placeholder="$t('termsemester.enteracademicterm')"
                  />
                  <div class="invalid-feedback" v-if="errors.has('term_name')">
                    {{ errors.first('term_name') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.weekday')
                }}</label>
                <div class="col-md-8">
                  <ts-search-select
                    v-model.number="model.weekday_id"
                    :options="weekdays"
                    @change="getTermOrder"
                  >
                  </ts-search-select>
                  <div class="validate" v-if="errors.has('weekday_id')">
                    {{ errors.first('weekday_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3 required">
                  {{ $t('termsemester.academicTermOrder') }}
                  <i
                    class="fas fa-spinner fa-pulse label-loading"
                    v-if="pull_term_order"
                  ></i>
                </label>
                <div class="col-md-8">
                  <input
                    v-model.number="model.term_order"
                    type="text"
                    class="form-control-plaintext"
                    :placeholder="$t('termsemester.academictermorder')"
                    readonly
                  />
                  <div class="validate" v-if="errors.has('term_order')">
                    {{ errors.first('term_order') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required"
                  >{{ $t('termsemester.startDate') }}/{{
                    $t('termsemester.stopDate')
                  }}</label
                >
                <div class="col-md-8">
                  <a-range-picker format="DD-MM-YYYY" @change="dateRangeChange">
                  </a-range-picker>
                  <div
                    class="validate"
                    v-if="errors.has('term_start') || errors.has('term_stop')"
                  >
                    {{
                      errors.first('term_start') || errors.first('term_stop')
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 text-right">
              <hr />
              <ts-button
                class="btn-primary mr-2"
                :waiting="waiting_save_new"
                @click.prevent="saveAddNew"
              >
                {{ $t('save_add_new') }}
              </ts-button>
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="store"
                :waiting="waiting_save"
              >
                {{ $t('save') }}
              </ts-button>
              <ts-button
                class="btn-default"
                @click.prevent="$router.push({ name: 'term-semester' })"
              >
                {{ $t('cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'term-semester-create',
  data() {
    return {
      errors: new Errors(),
      waiting_save: false,
      waiting_save_new: false,
      pull_term_order: false,
      model: {
        ac_year_id: '',
        acps_id: '',
        level_id: '',
        term_name: '',
        term_start: '',
        term_stop: '',
        term_order: '',
        weekday_id: ''
      }
    }
  },
  created() {
    this.selectDefaultCurrentYear()
  },
  computed: {
    ...mapState('termSemester', ['acYears']),
    subPrograms() {
      return this.$store.state.termSemester.subPrograms.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign
      }))
    },
    levels() {
      return this.$store.state.termSemester.levels
        .filter(l => l.acps_id == this.model.acps_id)
        .map(el => ({
          value: el.level_id,
          text: el.level_name
        }))
    },
    weekdays() {
      return this.$store.state.termSemester.weekdays.map(el => ({
        value: el.weekday_id,
        text: el.week_day
      }))
    }
  },
  methods: {
    selectDefaultCurrentYear() {
      if (this.acYears.length > 0) {
        let currentYear = this.acYears.filter(y => y.ac_status_id == 1)
        if (currentYear[0]) {
          this.model.ac_year_id = currentYear[0].ac_year_id
        }
      }
    },
    store() {
      this.waiting_save = true
      this.$store
        .dispatch('termSemester/store', this.model)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'term-semester' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_save = false
        })
    },
    saveAddNew() {
      this.waiting_save_new = true
      this.$store
        .dispatch('termSemester/store', this.model)
        .then(response => {
          this.waiting_save_new = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_save_new = false
        })
    },
    getTermOrder() {
      if (this.model.level_id && this.model.ac_year_id) {
        this.pull_term_order = true
        this.$store
          .dispatch('termSemester/getTermOrder', {
            acYearId: this.model.ac_year_id,
            acpsId: this.model.level_id,
            weekdayId: this.model.weekday_id
          })
          .then(response => {
            this.model.term_order = parseInt(response.term_order)
            this.pull_term_order = false
          })
      } else {
        this.model.term_order = ''
        this.$toasted.info('Please select academic year and sub program')
      }
    },
    clearInput() {
      this.model = {
        ac_year_id: '',
        acps_id: '',
        level_id: '',
        term_name: '',
        term_start: '',
        term_stop: '',
        term_order: ''
      }
      this.selectDefaultCurrentYear()
    },
    dateRangeChange(dateRange) {
      this.model.term_start = dateRange[0].format('DD-MM-YYYY')
      this.model.term_stop = dateRange[1].format('DD-MM-YYYY')
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('termSemester/RESET_STATE')
      this.$store.commit('termSemester/SET_EDIT_DATA', {})
      this.$store.commit('termSemester/GET_SUB_PROGRAM', [])
      this.$store.commit('termSemester/GET_AC_YEAR', [])
      this.$store.commit('termSemester/GET_WEEKDAY', [])
    }
    next()
  }
}
</script>
